import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'isomorphic-dompurify';
import type { ITermsConditionModalProps } from '../../types/propTypes';

const TermsAndConditionModal = ({
  modal,
  isShowCloseButton,
  closeTermsModal,
  isShowAccceptButton,
}: ITermsConditionModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={modal.showModal}
      scrollable
      className="font-poppins"
      onHide={isShowCloseButton ? closeTermsModal : () => {}}
    >
      <Modal.Body style={{ lineHeight: 'normal' }}>
        {isShowCloseButton && (
          <div className="d-flex justify-content-end">
            <button type="button" className="close m-1" onClick={closeTermsModal}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">{t('Payment.Model.button.close')}</span>
            </button>
          </div>
        )}

        <div className="terms-and-conditions-title mb-4">{t('signup.termsAndConditionModal.header')}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(modal.body),
          }}
        ></div>
      </Modal.Body>
      {isShowAccceptButton && (
        <Modal.Footer>
          <Button
            className="btn btn-primary w-100 mx-5 terms-and-condition-accept-button"
            onClick={() => modal.callBack && modal.callBack()}
            title={t<string>('signup.termsAndConditionModal.button.accept')}
          >
            {t('signup.termsAndConditionModal.button.accept')}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default TermsAndConditionModal;
